import React, { useEffect, useState } from "react";
import { Header, Grid, Divider, Button } from "semantic-ui-react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import { useNavigate } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const ListEmp = () => {
  const navigate = useNavigate();

  const userDetail = userData();
  useEffect(() => {
    getEmployeeList();
  }, []);
  const [rowData, setrowData] = useState(null);
  const getEmployeeList = () => {
    axios
      .get(BaseUrl + "getBackOfficeUserList")
      .then((res) => {
        console.log(res.data);
        setRecordForTable(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setRecordForTable = (record) => {
    const tempRecord = record.map(
      ({
        userId,
        userFirstName,
        userLastName,
        email,
        designation,
        userRole,
      }) => ({
        userId: userId,
        userFirstName: userFirstName,
        userLastName: userLastName,
        email: email,
        designation: designation,
        userRole: getRoleType(userRole),
      })
    );
    setrowData(tempRecord);
  };

  const getRoleType = (role) => {
    if (role === 1) {
      return "Admin";
    } else if (role === 2) {
      return "IT";
    } else if (role === 3) {
      return "Accounts";
    } else if (role === 4) {
      return "Sales";
    } else if (role === 5) {
      return "Marketting";
    }
  };
  const columnDefs = [
    { headerName: "F_Name ", field: "userFirstName" },

    { headerName: "L_Name", field: "userLastName" },
    { headerName: "Email", field: "email" },
    { headerName: "Designation", field: "designation" },
    { headerName: "Role", field: "userRole" },
    {
      headerName: "Actions",
      filter: false,
      field: "email",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            View{" "}
          </Button>
          {userDetail.userRole == 1 && (
            <Button color="red" onClick={() => deleteRecord(params)}>
              delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const deleteRecord = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrl + "deleteBackOfficeUser", {
            userId: params.data.userId,
          })
          .then((res) => {
            console.log("res", res.data);
            Swal.fire("Deleted!", "User Recored has been deleted.", "success");
            getEmployeeList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const actionButton = (params) => {
    navigate(`/create-employee/${params.data.email}`);
  };
  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Employee List
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <div className="ag-theme-alpine" style={{ height: 600 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          pagination={true}
        ></AgGridReact>
      </div>
    </div>
  );
};

export default ListEmp;
